export default function AssistantMessage({ children }: { children: React.ReactNode }) {
	return (
		<div className='flex gap-2'>
			<img alt='' src='/tutorcat-icon.svg' className='w-[33px] h-[33px] p-1' />
			{children}
		</div>
	)
}
